// extracted by mini-css-extract-plugin
export default {"root":"Text_root__09FvP","regular":"Text_regular__eMn3L","semiBold":"Text_semiBold__dloOM","caption":"Text_caption__FEAaY"};